import React from 'react'
import ReactModal from 'react-modal'
import { Form } from 'react-bootstrap'
import CloseBtn from '../../buttons/CloseBtn'
import RequieredInputs from '../../common/RequiredInputs'
import { BusinessUnitMultiSelect } from '../../fields'
import _ from 'lodash'

const UserModal = ({
  modalIsOpen,
  closeModal,
  inputs,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
  communities = [],
  businessunits = [],
  colors = [],
  rolesList = [],
  isEdit = false,
}) => {
  // const sortedZones = _.orderBy(zones, ['nombre'], ['asc'])
  const sortedBusinessunits = _.orderBy(businessunits, ['nombre'], ['asc'])

  // Estilos personalizados para el modal, siguiendo el patrón de EventsModal
  const customStyles = {
    content: {
      width: '90%',
      maxHeight: '90vh',
      padding: '25px',
      overflow: 'auto',
      zIndex: 2,
    },
  }

  // Títulos dinámicos según el modo
  const modalTitle = isEdit ? 'Editar usuario' : 'Crear nuevo usuario'
  const contentLabel = isEdit ? 'Editar usuario' : 'Crear nuevo usuario'

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
      className='custom-modal'
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>{modalTitle}</h4>

      <Form onSubmit={handleSubmit} className='modal__form'>
        {/* Contenedor adaptable para todos los campos */}
        <div className='modal-form-container'>
          {/* Primera fila: Nombre y Email */}
          <div className='modal-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Nombre y Apellidos <RequieredInputs />
              </Form.Label>
              <Form.Control
                type='text'
                className='user-input form__input'
                name='nombre'
                value={inputs.nombre || ''}
                onChange={handleChange}
                placeholder='Nombre y Apellidos'
              />
            </Form.Group>
          </div>

          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Email <RequieredInputs />
              </Form.Label>
              <Form.Control
                type='email'
                className='user-input form__input'
                name='email'
                value={inputs.email || ''}
                onChange={handleChange}
                placeholder='Email'
              />
            </Form.Group>
          </div>

          {/* Segunda fila: Rol, Color, Teléfono */}
          <div className='modal-form-field modal-form-field--medium'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Rol <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_Rol'
                value={inputs.id_Rol || ''}
                onChange={handleChange}
              >
                <option value=''>Elegir Rol</option>
                {rolesList.map((role) => (
                  <option key={role.id_Rol} value={role.id_Rol}>
                    {role.nombre}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div>

          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Teléfono</Form.Label>
              <Form.Control
                type='text'
                className='user-input form__input'
                name='telefono'
                value={inputs.telefono || ''}
                onChange={handleChange}
                placeholder='Teléfono'
              />
            </Form.Group>
          </div>

          {/* Tercera fila: Zona y Unidades de Negocio */}
          {/* <div className='modal-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Comunidad</Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_TipoZona'
                value={inputs.id_TipoZona || ''}
                onChange={handleChange}
              >
                <option value=''>
                  {inputs.id_TipoZona === ''
                    ? 'Elegir Comunidad'
                    : 'Sin comunidad'}
                </option>
                {communities.map((community) => (
                  <option key={community} value={community}>
                    {community}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </div> */}

          <div className='modal-form-field modal-form-field--component'>
            <BusinessUnitMultiSelect
              value={
                inputs.businessUnits && Array.isArray(inputs.businessUnits)
                  ? inputs.businessUnits.map((bu) => bu.id_NegocioUnidad)
                  : []
              }
              onChange={(selectedIds) => {
                // Convertir IDs a objetos completos usando businessunits del prop
                const selectedBusinessUnits = selectedIds
                  .map((id) =>
                    sortedBusinessunits.find(
                      (bu) => bu.id_NegocioUnidad === id,
                    ),
                  )
                  .filter(Boolean) // Filtrar undefined

                // Llamar handleChange que ahora sincroniza businessUnits y negocioUnidadesObj
                handleChange({
                  target: {
                    name: 'businessUnits',
                    value: selectedBusinessUnits,
                  },
                })
              }}
              label='Unidades de Negocio'
              placeholder='Selecciona las unidades de negocio...'
              compact
            />
          </div>

          {/* Mostrar tipos de categoría si existen */}
          {inputs &&
            inputs.tipoCategorias &&
            inputs.tipoCategorias.length > 0 && (
              <div className='modal-form-field modal-form-field--full-width'>
                <Form.Group size='lg'>
                  <Form.Label className='form__labels'>
                    Tipos de Categoría
                  </Form.Label>
                  <div
                    className='user-input form__input'
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      fontSize: '14px',
                      padding: '8px',
                    }}
                  >
                    {inputs.tipoCategorias.join(', ')}
                  </div>
                </Form.Group>
              </div>
            )}
        </div>

        <div className='modal-form-actions'>
          <button
            onClick={handleSubmit}
            disabled={!validateForm()}
            className='btn save create'
            type='submit'
          >
            {textBtn}
          </button>
        </div>
      </Form>
    </ReactModal>
  )
}

ReactModal.setAppElement('#root')
export default UserModal
